export class CheckResult {
	constructor(text: string, resultLevel: number) {
		this.text = text;
		this.resultLevel = resultLevel;
	}
	public text: string;
	public resultLevel: number;
}